import zhCN from "./zh-CN";
import enUS from "./en-US";

export default {
  "zh-CN": zhCN,
  "en-US": enUS,
};
